// src/components/widgets/ExpediaSearchWidget.jsx
import { Box } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";

export default function ExpediaSearchWidget({ snippet = "" }) {
  const iframeRef = useRef(null);
  const containerRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState(0);

  useEffect(() => {
    const iframeElement = iframeRef.current;
    if (!iframeElement) return;

    const measure = () => {
      try {
        const doc =
          iframeElement.contentDocument || iframeElement.contentWindow?.document;
        if (!doc) return;
        const newHeight = Math.max(
          doc.body?.scrollHeight || 0,
          doc.documentElement?.scrollHeight || 0
        );
        if (newHeight && newHeight !== iframeHeight) {
          setIframeHeight(newHeight);
        }
      } catch (e) {
        // Ignore cross-origin or transient access issues
      }
    };

    const onLoad = () => {
      measure();
      try {
        const doc =
          iframeElement.contentDocument || iframeElement.contentWindow?.document;
        if (!doc) return;
        const observer = new MutationObserver(measure);
        observer.observe(doc.body, {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true,
        });
        iframeElement.__observer = observer;
        iframeElement.contentWindow?.addEventListener("resize", measure);
      } catch (e) {
        // No-op if observers cannot be attached
      }
    };

    iframeElement.addEventListener("load", onLoad);
    // In case srcDoc is already loaded synchronously
    onLoad();

    return () => {
      iframeElement.removeEventListener("load", onLoad);
      try {
        iframeElement.__observer?.disconnect();
        iframeElement.contentWindow?.removeEventListener("resize", measure);
      } catch (e) {
        // ignore
      }
    };
  }, [snippet, iframeHeight]);

  return (
    <Box
      ref={containerRef}
      w={{ base: "90%", md: "65%", lg: "65%" }}
      borderRadius="xl"
      overflow="visible"
      bg="#F6F6F6"
      p={3}
      mt={2}
       h="auto"
      style={{ height: "auto" }}
    >
      <iframe
        ref={iframeRef}
        title="Expedia widget"
        style={{
          width: "100%",
          height: iframeHeight ? `${iframeHeight}px` : "auto",
          border: "none",
          display: "block",
          overflow: "hidden",
        }}
        scrolling="no"
        srcDoc={`<!doctype html>
<html>
  <head>
    <meta charset="utf-8"/>
    <style>
      html, body {
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        overflow: visible;
        font-family: Arial, sans-serif;
      }
      body {
        display: block;
        line-height: 1;
      }
      * {
        box-sizing: border-box;
      }
      .bucket-section {
        margin-top: 20px;
        text-align: center;
        padding: 10px;
      }
      .bucket-divider {
        width: 100%;
        height: 1px;
        background: #E2E8F0;
        margin: 15px 0;
      }
      .bucket-text {
        font-size: 12px;
        color: #666;
        margin-bottom: 10px;
      }
      .bucket-button {
        background: #286328;
        color: white;
        border: none;
        padding: 8px 16px;
        border-radius: 8px;
        font-size: 12px;
        cursor: pointer;
        transition: background 0.2s;
      }
      .bucket-button:hover {
        background: #1F4D1F;
      }
    </style>
  </head>
  <body>
    ${snippet}
    <div class="bucket-section">
      <div class="bucket-divider"></div>
      <div class="bucket-text">Did you find what you were looking for? Add them to your bucket list.</div>
      <button class="bucket-button" onclick="window.parent.location.href='/ai-travel-planner/bucket-list?fromChat=true'">Go to Bucket List</button>
    </div>
  </body>
</html>`}
      />
     </Box>
  );
}
